<!-- 职位详情 -->
<template>
  <div class="details">
    <!-- 导航栏 -->
    <div class="nav-bar">
      <div class="nav-box">
        <img src="@/assets/img/position/back.png" class="nav-img" @click="bindtaps(0)" />
        <div
          class="nav-item"
          :style="type==0?'justify-content:flex-end':'justify-content:space-between'"
        >
          <img src="@/assets/img/position/share.png" class="nav-img" @click="bindtaps(1)" />
          <img
            v-if="type!=0"
            :src="collected==undefined?imgs[0]:collected==1?imgs[1]:imgs[0]"
            class="nav-img"
            @click="bindtaps(2)"
          />
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="detais-container">
      <!-- 招聘职位 -->
      <div class="details-position">
        <div class="details-title">
          <span>{{type==0?details.name:details.job_name}}</span>
          <span
            v-show="details.open_status==1"
          >{{details.salary_type==0?details.min_salary==details.max_salary?details.max_salary:`${details.min_salary}-${details.max_salary}`:'面议'}}</span>
          <span v-show="details.open_status==0">停止招聘</span>
        </div>
        <div class="details-request">
          <div class="details-item">
            <img src="@/assets/img/position/position.png" class="details-img" />
            <span>{{details.district_name}}</span>
          </div>
          <div class="details-item">
            <img src="@/assets/img/position/experience.png" class="details-img" />
            <span>{{details.experience==0?'不限':details.experience}}</span>
          </div>
          <div class="details-item">
            <img src="@/assets/img/position/degree.png" class="details-img" />
            <span>{{details.education==0?'不限':details.education}}</span>
          </div>
          <div class="details-item">
            <img src="@/assets/img/position/peopleNum.png" class="details-img" />
            <span>{{details.amount==0?'不限':`招${details.amount}人`}}</span>
          </div>
        </div>
      </div>
      <div v-if="details.open_status==1">
        <!-- 职位描述 -->
        <div class="details-desc">
          <p>职位描述</p>
          <div class="details-text">
            <!-- <p class="text-title">{{details.description.length==0?'还没添加职位描述哦~':''}}</p> -->
            <p class="text-content" v-html="details.description"></p>
          </div>
        </div>

        <!-- 职位福利 -->
        <div class="details-desc">
          <p>职位福利</p>
          <div class="welfare-box">
            <span v-for="(item,index) in details.tag" :key="index">{{item}}</span>
            {{details.tag==0?'还没有添加福利哦~':''}}
          </div>
        </div>
        <!-- 公司信息 -->
        <div class="details-desc" v-if="type!=0">
          <p>公司信息</p>
          <!-- <router-link to="/position/componyDetails"> -->
          <div class="componey-info" @click="navCompany(details.company_id)">
            <div class="componey-item">
              <img :src="details.company_logo" class="logo" />
              <div class="componey-message">
                <p>{{details.company_name}}</p>
                <p>{{details.company_address}}</p>
              </div>
            </div>
            <img src="@/assets/img/position/into.png" class="into" />
          </div>
          <!-- </router-link> -->
        </div>
      </div>

      <!-- 停止招聘 -->
      <p class="stop-recruitment" v-if="details.open_status==0">该职位已关闭</p>
    </div>
    <!-- 申请按钮 -->
    <div class="request-btn" v-if="details.open_status==1&&type!=0">
      <button
        :class="{'btns':true,'applied':details.is_apply==1}"
        :disabled="details.is_apply==1"
        @click="requestReply(details.job_id)"
      >{{details.is_apply?details.is_apply==0?'申请':'已申请':'申请'}}</button>
    </div>
    <!-- 分享 -->
    <van-share-sheet v-model="showShare" title="立即分享给好友" :options="options" @select="onSelect" />
    <div class="overly" v-if="shows" @click="shows=false"></div>
    <img src="../../assets/img/home/share.png" class="share" v-if="shows" @click="shows=false" />
    <!-- boss端 -->
    <div class="btn" v-if="type==0">
      <button class="clear" @click="navLink">编辑</button>
      <button
        class="confirm"
        @click="closePosition(details.open_status)"
      >{{details.open_status==0?'职位开启':'关闭职位'}}</button>
    </div>
  </div>
</template>

<script>
import {
  getPositionDetails,
  cancelCollect,
  confirmCollect,
  releaseDetails,
  releaseClose,
  positionReply,
  openPosition
} from "@/api/apiData";
import { Toast } from "vant";
import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  inject: ["Token"],
  data() {
    return {
      id: "", //职位id
      show: false, //停止招聘
      collected: 0, //是否收藏
      imgs: [
        require("@/assets/img/position/collection.png"),
        require("@/assets/img/position/collected.png")
      ],
      type: "", //0 boss端
      details: "", //详情
      showShare: false,
      shows: false,
      options: [
        { name: "微信", icon: "wechat", type: "wechat" },
        { name: "微博", icon: "weibo", type: "sina" }
      ]
    };
  },
  computed: {
    ...mapState(["token"])
  },
  methods: {
    ...mapMutations(["keepAliveRouter"]),
    // 返回  分享 收藏
    bindtaps(val) {
      var that = this;
      if (val == 0) {
        // 返回上一页
        that.$router.back();
      } else if (val == 1) {
        that.showShare = true;
        // 分享
      } else {
        //   收藏
        that.cancel();
      }
    },
    // 分享选择
    onSelect(option) {
      var type = option.type;
      //新浪微博接口的传参
      if (type == "sina") {
        // //(document.location.href);
        window.open(
          "http://service.weibo.com/share/share.php?url=" +
            document.location.href +
            "?id=" +
            this.id
        );
      }
      // 微信分享
      if (type == "wechat") {
        this.shows = true;
      }
      this.showShare = false;
    },
    //编辑 跳转
    navLink() {
      this.keepAliveRouter("index");
      this.$router.push(
        `/management/editPosition?open_status=${this.details.open_status}&job_id=${this.details.job_id}`
      );
    },
    // 职位开启 关闭
    closePosition(status) {
      var that = this;
      var obj = {
        job_id: that.id
      };
      if (status === "0") {
        openPosition(obj).then(res => {
          // 开启
          if (res.code == 1) {
            Toast.success({
              forbidClick: false,
              message: "职位开启成功"
            });
            this.getDetails();
          } else {
            Toast.fail({
              forbidClick: false,
              message: res.msg
            });
          }
        });
      } else {
        // 关闭
        releaseClose(obj).then(res => {
          // //(res);
          if (res.code == 1) {
            Toast.success({
              forbidClick: true,
              message: "职位关闭成功"
            });
            this.getDetails();
            // setTimeout(() => {
            //   that.$router.back();
            // }, 1500);
          } else {
            Toast(res.msg);
          }
        });
      }
    },
    // 收藏功能
    cancel() {
      var that = this;
      var collected = that.collected;
      let obj = {
        job_id: that.id
      };
      if (collected == 0) {
        // 收藏
        that.Token(
          confirmCollect(obj).then(res => {
            //(res);
            if (res.code == 1) {
              that.collected = 1;
              Toast("收藏成功");
            } else {
              Toast("收藏失败");
            }
          })
        );
      } else {
        // 取消收藏
        that.Token(
          cancelCollect(obj).then(res => {
            //(res);
            if (res.code == 1) {
              that.collected = 0;
              Toast("取消收藏");
            } else {
              Toast("取消失败");
            }
          })
        );
      }
      // if (!token) {
      //   Dialog.confirm({
      //     title: "提示",
      //     message: "您还没有登录,是否现在就去登录"
      //   })
      //     .then(() => {
      //       this.$router.replace({
      //         name: "Login"
      //       });
      //     })
      //     .catch(() => {});
      // } else {
      // }
    },
    // 用户端   获取详情
    getDetails() {
      var that = this;
      var id = that.id;
      var type = that.type;
      let obj = {
        job_id: id,
        token: that.token
      };
      if (type == 0) {
        releaseDetails(obj).then(res => {
          if (res.code == 1) {
            that.details = res.data;
          }
        });
      } else {
        getPositionDetails(obj).then(res => {
     
          if (res.code == 1) {
            that.details = res.data;
            that.collected = res.data.is_collect;
          } else {
            Toast(res.msg);
            setTimeout(() => {
              that.$router.back();
            }, 2000);
          }
        });
      }
    },
    // 查看公司详情
    navCompany(id) {
      var that = this;
      that.$router.push({
        name: "ComponyDetails",
        query: {
          id: id
        }
      });
    },
    //申请职位
    requestReply(id) {
      this.Token(
        positionReply({ job_id: id }).then(res => {
          //(res);
          if (res.code == 1) {
            this.getDetails();
          } else {
            Toast.fail({
              message: res.msg,
              forbidClick: true
            });
          }
        })
      );
    }
  },
  created() {
    if (this.$route.params.show) {
      this.show = this.$route.params.show;
    }

    this.id = this.$route.query.id;
  },
  mounted() {
    this.type = this.$route.query.type;
    this.getDetails();
  }
};
</script>
<style lang='less' scoped>
.overly {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
}
.share {
  width: 3rem;
  height: 3rem;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
}
// 导航栏
.nav-bar {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  .nav-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem 0.32rem;
    z-index: 999;
    background: #fff;
    .nav-img {
      width: 0.4rem;
      height: 0.4rem;
    }
    .nav-item {
      display: flex;
      align-items: center;
      width: 15%;
      justify-content: space-between;
    }
  }
}
.nav-bar::after {
  content: "";
  display: block;
  height: 0.8rem;
  width: 100%;
}

// 内容
.detais-container {
  padding: 0.4rem 0.32rem 0;
  //   招聘职位
  .details-position {
    .details-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 0.48rem;
        font-weight: bold;
        line-height: 0.67rem;
        color: rgba(51, 51, 51, 1);
      }
      span:nth-child(2) {
        font-size: 0.36rem;
        font-weight: bold;
        color: rgba(255, 67, 67, 1);
      }
      span:nth-child(3) {
        font-size: 0.36rem;
        font-weight: 400;
        line-height: 0.5rem;
        color: rgba(179, 179, 179, 1);
      }
    }
    .details-request {
      display: flex;
      align-items: center;
      width: 100%;
      flex-wrap: wrap;
      border-bottom: 0.01rem solid #e5e5e5;
      padding-bottom: 0.4rem;
      .details-item {
        display: flex;
        align-items: center;
        margin-right: 0.2rem;
        padding-top: 0.2rem;
        .details-img {
          width: 0.3rem;
          height: 0.3rem;
          margin-right: 0.08rem;
        }
        span {
          font-size: 0.26rem;
          font-weight: 400;
          line-height: 0.37rem;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
  }
  //   职位描述
  .details-desc {
    margin-top: 0.4rem;
    p {
      text-align: left;
      font-size: 0.32rem;
      font-weight: bold;
      line-height: 0.45rem;
      color: rgba(51, 51, 51, 1);
    }
    .details-text {
      padding: 0.3rem 0 0.4rem;
      border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
      p {
        margin-top: 0.3rem;
        font-size: 0.26rem;
        font-weight: 400;
        line-height: 0.48rem;
        color: #666666;
      }
    }
    //   职位福利
    .welfare-box {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      padding: 0.3rem 0 0.4rem;
      border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
      font-size: 0.3rem;
      color: rgba(77, 77, 77, 1);
      span {
        padding: 0.06rem 0.1rem;
        background: rgba(248, 248, 248, 1);
        border-radius: 0.04rem;
        color: rgba(77, 77, 77, 1);
        font-size: 0.24rem;
        line-height: 0.33rem;
        margin-right: 0.16rem;
        margin-bottom: 0.16rem;
      }
    }
    // 公司信息
    .componey-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .componey-item {
        display: flex;
        align-items: center;
        padding: 0.3rem 0 0.4rem;
        .logo {
          width: 0.84rem;
          height: 0.84rem;
          margin-right: 0.16rem;
        }
        .componey-message {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 75%;
          p {
            font-size: 0.3rem;
            font-weight: bold;
            line-height: 0.48rem;
            color: rgba(51, 51, 51, 1);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          p:nth-child(2) {
            font-size: 0.24rem;
            font-weight: 400;
            line-height: 0.33rem;
            color: rgba(128, 128, 128, 1);
          }
        }
      }
      .into {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
  }
}
.detais-container::after {
  content: "";
  display: block;
  height: 1.5rem;
  width: 100%;
}

// 停止招聘
.stop-recruitment {
  font-size: 0.26rem;
  font-weight: 400;
  line-height: 0.48rem;
  color: rgba(102, 102, 102, 1);
  padding-top: 0.5rem;
  text-align: left;
}
//已申请
.applied {
  background: rgba(204, 204, 204, 1) !important;
}
</style>